module.exports = __webpack_public_path__ + "img/sending-green120.7a2b4ebc.gif";